<style lang="less">
    	#try_on_stage {
			height: 30rem;
			width: 30rem;
			overflow: hidden;
			/*background-color: #aca;*/
		}

		.ajax-loading {
			display: none;
			position: fixed;
			z-index:10;
		    top: 20%;
		    left: 50%;
		    opacity: .8;
		    height: 100px;
		    width: 100px;
		    transform: translate(-50%);
		}
		.ajax-loading img {
			width: 100%;
		}
</style>
<template>
    <div>
         	<!-- <div id="js_ajax_loading" class="ajax-loading">
		<img src="/demo/loading.gif" alt="loading...">
	</div>

	<div id="try_on_stage"></div>

	<button @click="initTryOn()" >开始试戴</button>

	<button @click="changeUserImage()" >切换用户图片</button>

	<button @click="changeHair()" >更换发型</button>

	<button @click="reset()" >重置</button>

	<form id="adjust_scale" >

		<label for="scale_ratio">放大倍数</label>
		<input id="scale_ratio" name="user" type="text" value="3.5" @change="changeScaleRatio()">

	</form>

	<label for="roll_angle">发型旋转</label>
	<input id="roll_angle"
			type="range" max="50" min="-50" step="0.1"
			@input="rotateHair($event)"
			@change="rotateHair($event)" >

	<form id="upload_user_form">
		<label for="user_img_input">上传</label>
		<input name="user_img" @change="imageFileTryOn()" type="file" id="user_img_input">
		<button type="button" @click="imageFileTryOn()" >试戴本地用户图片</button>
	</form> -->
       <iframe  name = "child" id = "child" v-bind:src="reportUrl"
   width="auto" height="300"
     frameborder="0" scrolling="no"  style="width:100%;height:1000px"
    ></iframe>
    </div>
</template>
<script>
// import { XjHairTryOn } from '../../../../xj-hair-tryon.js'
export default {
    data(){
        return{
           loading_elem:null,
           XJ:null,
           center_shift_pos :{ x : 0  , y : 0 },
         reportUrl: 'https://tryon.xiaojingxiuxiu.com/demo/hair-tryon-demo.html',
           file_input_elem:null

        }
    },
    mounted() {
        // this.XJ=XjHairTryOn({

		// 	// 试戴区域挂载元素 id 必需是个块级元素
		// 	el : '#try_on_stage' ,

		// 	// 你的 appid
		// 	app_id : 'rGcbbba7ajhBf7xW0ujdJky4xryxby9W' ,

		// 	// 在后台用 md5( app_secret + token + timestamp ) 生成的签名，两小时内有效
		// 	signature : '18d64d54fb60cd6cc85e6f9051686f91' , //  demo for Windows
		// 	// signature : '0724f73b137fd0460091cda6d61c2c5f' , // demo for Mac

		// 	// unix 时间
		// 	timestamp : '1506395429' ,

		// 	// 也可以在模块初始化的同时
		// 	// 初始化素材
		// 	// user_img : 'http://gz.bcebos.com/benyamin/wemall/user/face/oTKMAtwbkkEP62OkcZ3FG_82T1d8.jpg' ,

		// 	// hair_img : 'http://gz.bcebos.com/benyamin/AX_glasses/model/2d/2d_panx_XJXT_4187_material_001.png' ,
		// });

		// console.log(this.XJ);

		// // 如果需要处理一些回调事件
		// // 可以订阅下列事件

		// // 调用 tryOn 方法会触发下列事件
		// // tryon.start
		// // tryon.error
		// // tryon.done

		// // 调用 adjust 方法会触发下列事件
		// // adjust.start
		// // adjust.done

		// // 调用 reset 方法会触发下列事件
		// // reset.start
		// // reset.done
		// //
        // // 比如显示加载 loading 图片
        //  this.XJ.on('tryon.start' , function () {
		// 	loading_elem.style.display = 'inherit';
		// 	console.info('tryon is begin');
		// })
		// .on('tryon.done' , function () {
		// 	loading_elem.style.display = 'none';
		// 	console.info('tryon is ok');
		// })
		// .on('tryon.error' , function ( msg ) {
		// 	loading_elem.style.display = 'none';
		// 	alert( "试戴失败：" + msg );
		// 	console.warn( msg );
        // });

        // var loading_elem = document.getElementById('js_ajax_loading');

        // var file_input_elem=document.getElementById('user_img_input')

        // this.file_input_elem=document.getElementById('user_img_input')
    },
    methods: {
        		// 初始化试戴模块



		// 开始试戴
		initTryOn(){

			// 初始化素材
			this.XJ.tryOn({
				user_img : this.userImageUrl(3) ,

                hair_img : 'https://gz.bcebos.com/try-on-api/hair2d/assets/a62777f9df0489058165b21a5757bdaa_2017_08_15.png',
			});

			// 初始化一个 hammer js 单例
			this.singleHammer();
		},

		singleHammer(){function singleton( initialized ){
			return function initializeHammer(){
				return initialized || ( initialized = hammerInit() );
			};
        }(false)
        },



		// hammer.js 是一个支持多触点手势识别的库
		// http://hammerjs.github.io/
		// 可以参考下面的代码加入自己的位置调整逻辑
		hammerInit(){

		    // 初始化 hammer 操作平面元素
		    var stage = document.getElementById('try_on_stage');
		    var mc = new Hammer.Manager(stage);

		    // 绑定手势
		    var Pan = new Hammer.Pan();
		    var DoubleTap = new Hammer.Tap({
		        event: 'doubletap',
		        taps: 2
		    });

		    mc.add(Pan);
		    mc.add(DoubleTap);

		    // 添加平移发型相关回调
		    mc.on('pan', function panGlass(e) {

		            var center_shift = {
		                x : this.center_shift_pos.x + e.deltaX,
		                y : this.center_shift_pos.y + e.deltaY
		            };

		            // 可以输入一个参数设置对象对试戴位置进行设置 传入对象如下
		            // {
		            // 	 pd_center : {
		            // 		x : 0 ,  // 发型水平轴相对于初始位置的像素偏移
		            // 		y : 0    // 发型垂直轴相对于初始位置的像素偏移
		            // 	 } ,
		            // }
		            this.XJ.adjust( {
		            	pd_center : center_shift ,
		            });

		    });
		    mc.on('panend', function(e) {
		    	this.center_shift_pos = {
		    		x : this.center_shift_pos.x + e.deltaX ,
		    		y : this.center_shift_pos.y + e.deltaY
		    	}
		    });

		    // 重置发型位置
		    mc.on('doubletap', function() {
		    	this.center_shift_pos = { x : 0 , y : 0 };

		    	// 可以调用 XJ.rest() 重置发型位置
		        this.XJ.reset();
		    });

		    console.log( 'hammer initialized');

		    return true;
		},

		// 替换用户图片
		changeUserImage(){

			// 可以分别切换素材 ，根据参数不同 ，自动判断并试戴
			this.XJ.tryOn({
				user_img : this.randUserImage( 1, 13 )
			});

		},

		/**
         * 替换发型图片
         */
		changeHair(){

			this.XJ.tryOn({

//				user_img : userImageUrl(9),

				hair_img : 'https://gz.bcebos.com/try-on-api/hair2d/assets/a62777f9df0489058165b21a5757bdaa_2017_08_15.png',

				reset : true // if reset is set XJ.reset() will be called automaticly
			});

		},

		/**
         * 调整发型缩放比例, 此比例是相对于识别出的用户图片瞳距的比例
         * 默认值为 3.5 倍瞳距
         */
		changeScaleRatio(){
			var adjust_form = document.getElementById('adjust_scale');
			var scale_ratio = adjust_form.scale_ratio.value || 3.5;

			this.XJ.adjust({
				scale_ratio : scale_ratio
			});
		},

		// 旋转发型
		rotateHair( degree ){

            // 	pose = {
            // 		roll_angle : 0 ,  //  发型z轴旋转角度偏移
            // 	}

			this.XJ.adjust({
        		pose : {
            		roll_angle : degree.target.value
            	}
            });
		},


		// 重置发型位置
		reset(){

			this.XJ.reset();

			// 网页上的调整参数也要同时重置
			this.center_shift_pos = { x : 0  , y : 0 };

			var adjust_form = document.getElementById('adjust_scale');
				adjust_form.user.value = 47;
				adjust_form.frame.value = 47;

			var rotate_input = document.getElementById('roll_angle');
				rotate_input.value = 0;
		},



		// 上传本地用户图片，需要传入 file input 元素的 id selector
		imageFileTryOn(){

            if (! this.isFileExist(this.file_input_elem)) {
                alert('请先选择一张正面头部图片,再点击试戴');
                return this.file_input_elem.click();
            }

			this.XJ.tryOn({
				user_img_el : "#user_img_input"
			});
		},

        isFileExist(file_elem) {
            return file_elem.files.length > 0
        },

        /**
         * 返回指定序号用户图片地址
         *
         * @param {number} index 1-16
         * @return {string}
         */
        userImageUrl( index ) {
			return "http://try-on-api.gz.bcebos.com/demo-assets/user-model/" + index + ".jpg";
		},

		// 获取一张不重复的用户图片地址
		randUserImage(old_index){
			return function randImage( floor , ceil ){
				var new_index = randInt( floor , ceil );
				if ( new_index === old_index ) {
					return this.randUserImage( floor , ceil );
				} else {
					old_index = new_index;
					return this.userImageUrl( new_index );
				}
			}
		},


		randInt( floor , ceil ){
			return Math.round( Math.random() * ( ceil - floor ) ) + parseInt( floor );
		}
    }
}
</script>

